const KEY = 'cfx-spotlight-cues';

function read(): Record<string, string> {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(KEY) || '{}');
    if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
    return Object.fromEntries(Object.entries(value).filter(([, id]) => typeof id === 'string'));
  } catch { return {}; }
}
function write(m: Record<string, string>) {
  try { sessionStorage.setItem(KEY, JSON.stringify(m)); } catch { /* private mode */ }
}

/** A cue is armed for a page only until it is used or the page is left. */
export function rememberCue(path: string, id: string) { write({ ...read(), [path]: id }); }
export function pendingCueFor(path: string): string | null { return read()[path] ?? null; }
export function clearCue(path: string, id?: string) {
  const m = read();
  if (id === undefined || m[path] === id) { delete m[path]; write(m); }
}

/** Append `cue=<id>` to a link so the target on that page lights up. */
export function withCue(to: string, cue?: string): string {
  if (!cue) return to;
  const [base, hash] = to.split('#');
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}cue=${encodeURIComponent(cue)}${hash ? `#${hash}` : ''}`;
}
